// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stanley-typing-text[data-v-ad497b58]{overflow:hidden}", "",{"version":3,"sources":["webpack://src/components/stanley/StanleyTypingText.vue"],"names":[],"mappings":"AAAA,sCAAsC,eAAe","sourcesContent":[".stanley-typing-text[data-v-ad497b58]{overflow:hidden}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
